import React, { useCallback } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

import { ScheduleFilters } from '../../types';

function ScheduleNoSearchResultsEmptyState({
  filters,
  setFilters,
}: {
  filters: ScheduleFilters;
  setFilters: (filters: ScheduleFilters) => void;
}) {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  const clearFilters = useCallback(() => {
    setFilters({ scheduleId: filters.scheduleId });
  }, [filters, setFilters]);

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
      title={T.translate('EMPTY_STATE.NO_RESULTS_TITLE')}
      description={T.translate('EMPTY_STATE.NO_RESULTS_SUBTITLE')}
    >
      <LinkButton onClick={clearFilters}>
        {T.translate('EMPTY_STATE.NO_RESULTS_LINK')}
      </LinkButton>
    </EmptyState>
  );
}

export default ScheduleNoSearchResultsEmptyState;
